import {IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonModal, useIonRouter, useIonViewWillEnter, useIonViewWillLeave} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';

import {fetch_pg_1_12, fetch_pg_1_25, fetch_pg_1_5, fetch_pg_1_6, Pg_1_12_Store, Pg_1_25_Store, Pg_1_6_Store, push_pg_1_12__Buy, push_pg_1_6__Buy} from "../store/Pg_1_Store";
import {getPageData, getQuotes} from "../store/Selectors";
import React, {Fragment, useEffect, useLayoutEffect, useRef, useState} from "react";
import {checkmarkOutline, chevronDownCircleOutline, copyOutline} from "ionicons/icons";
import {useParams} from "react-router";
import {TokenItem} from "../components/TokenItem";
import {ProductModal} from "../components/ProductModal";
import {Simulate} from "react-dom/test-utils";
import select = Simulate.select;
import Pg_1_6 from "./Pg_1_6";
import {useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import CustomPage from "./CustomPage";
import styles_TokenItem from "../components/TokenItem.module.scss";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";
import {TokenDetailItem} from "../components/TokenDetailItem";
import styles_1_25 from './Pg_1_25.module.scss';
import {fetch_pg_0_3} from "../store/Pg_0_Store";
import {handleFetchCommonErrors} from "./Utils";

const Pg_1_25 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_1_25";
    const pageId = "Pg_1_25";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    const {pageId: param_pageId}: any = useParams();

    const router = useIonRouter();

    useEffect(() => {
        (async () => {
            let errorObj = await fetch_pg_1_25({
                p1: param_pageId,
            });
            handleFetchCommonErrors(router, errorObj);
        })();
    }, [param_pageId]);

    useLayoutEffect(() => {
        Pg_1_25_Store.replace({});
    }, [param_pageId]);

    let reload = async (event: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_pg_1_25({
            p1: param_pageId,
        });
        handleFetchCommonErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_1_25_Store, getPageData);



    const hasLoaded = pgData?.Root ?? false;
    const Item_通用頁面 = hasLoaded ? pgData.Root.Item_通用頁面 : undefined;
    //#endregion

    ///<div className={styles_1_25.iframeStyle} dangerouslySetInnerHTML={{__html: Item_通用頁面.內容}}/>
    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={true}>
                {/*<PageHeader count={ sideMenuOptions.length } pageName={ pageName } />*/}
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded &&
                    <>
                        <div className={styles_1_25.iframeWrap}>
                            <iframe className={styles_1_25.iframe} src={`https://www.labie.io/${Item_通用頁面.選填_映射路徑}`}></iframe>
                        </div>
                    </>
                }
            </CustomPage>


        </IonPage>
    );
};

export default Pg_1_25;
